import { Currency } from "@goodfill/domain-properties";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { userDataState } from "../../../state";
import { Heading3, Paper } from "@goodfill/ui-components";
import { PricedBond } from "../PricedBond";
import { BatchBuyDialogTable, BatchBuyPresentedRowToBuy } from "./BatchBuyDialogTable";

export const BatchBuyDialog = ({ rows }: { rows: PricedBond[] }) => {
  const tradeDate = useMemo<DateTime>(() => DateTime.local(), []);
  const userData = useRecoilValue(userDataState);

  if (userData == null) {
    return <>ERROR: User not logged</>;
  }

  const balanceAccount = userData.getBalanceAccount(Currency.USD);

  if (balanceAccount === null) {
    return <>ERROR: BalanceAccount not loaded</>;
  }

  const mappedRows = rows.map((pricedBond): BatchBuyPresentedRowToBuy => {
    return {
      bond: pricedBond,
      presented: {
        couponPayment: pricedBond.couponPayment,
        ticker: pricedBond.issuerTicker,
        issuerName: pricedBond.issuerName,
        maturityDate: pricedBond.maturityDate,
      },
    };
  });

  return (
    <Paper white>
      <div className="py-12 px-12 flex flex-col" style={{ width: "90vw" }}>
        <Heading3>Buy bonds</Heading3>
        <BatchBuyDialogTable moneyBalanceAccount={balanceAccount} rows={mappedRows} tradeDate={tradeDate} />
      </div>
    </Paper>
  );
};
